"use strict";
const angular = require("angular");

const uiRouter = require("angular-ui-router");

import routes from "./pdashboard.routes";

export class PdashboardComponent {
  /*@ngInject*/
  constructor(
    $http,
    $scope,
    $anchorScroll,
    $state,
    lookup,
    $window,
    $location,
    db,
    $timeout,
    theme
  ) {
    this.$http = $http;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$state = $state;
    this.$anchorScroll = $anchorScroll;
    this.$scope.currentSites = [];
    

    this.$window = $window;
    this.$location = $location;
    this.theme = theme;

    this.lookup = lookup;
    this.db = db;
    this.$scope.user = {};

    this.$scope.county = 'Alameda';
    this.$scope.countyJuris = 'Alameda';
    this.$scope.jurisdiction = 'Alameda';

    this.$scope.showCountyTitle = false;
    this.$scope.showRegionTitle = true;
    this.$scope.showJurisTitle = false;
  }

  $onInit() {
     // Show data disclaimer 
     var modalCheck = this.lookup.getModalCheck('dashboard');
     console.log(modalCheck);
     if(!modalCheck){
       $('#dataDisclaimerModal').modal();
       this.lookup.setModalCheck('dashboard', true);
     }
    this.$scope.geo = 'regional';
    this.$scope.regionalIsLoaded = false;
    this.$scope.countyIsLoaded = false;
    this.$scope.jurisdictionIsLoaded = false;

    this.loadCountyList();
    this.loadJurisdictions(this.$scope.countyJuris);
    
    this.$http
    .get(`https://api.mtcanalytics.org/api/mode/dashboard/${this.$scope.geo}/regional`)
    .then((response) => {
      this.$scope.regionalUrl = response.data;
      console.log(response);
      console.log("response 1");
      
      window.onload = this.loadIframe(this.$scope.regionalUrl);
      
    })
    .catch((err) => {
      console.log(err);
    });



    // Mode Iframe

    //Load theme functions
    this.theme.initTheme();

       window.addEventListener("message", function (e) {
      console.log(e);
      //Hide Filters
      // const message = {
      //   type: "reportFilterPanelDisplay",
      //   togglePanel: true,
      // };
      const iframe = window.document.querySelector("iframe");
      iframe.contentWindow.postMessage(message, "*");

      // always check the origin and make sure it is from app.mode.com
      if (e.origin === "https://app.mode.com") {
        if (e.data["type"] == "reportExportPaths") {
          const modeBaseUrl = e.origin;

          // CSV Export
          const csvExportUrl = e.data["report_csv_export_path"];
          var csvExportLink = $("#csv-export-link");
          csvExportLink.href = modeBaseUrl + csvExportUrl;
          console.log(csvExportLink);
        }
      }
    });
  }

  loadCountyList() {
    console.log("running...");
    this.$http
      .get("https://data.bayareametro.gov/resource/v6h3-e68p.json?$select=basis_county&$group=basis_county&$order=basis_county")
      .then((response) => {
        console.log(response.data);
        this.$scope.countyList = response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  loadJurisdictions(county) {
      this.$http
        .get(
          `https://data.bayareametro.gov/resource/v6h3-e68p.json?basis_county='${county}'`
        )
        .then((response) => {
          this.$scope.jurisdictionList = response.data;
          console.log(this.$scope.jurisdictionList);
          
        })
        .catch((err) => {
          console.log(err);
        });
 
  }


  loadIframe(url) {
    // Embed Mode Iframe
    this.$scope[`${this.$scope.geo}Url`] = url;
    var geo = this.$scope.geo;
    console.log(geo);
    console.log(url);
    var $scope = this.$scope;
    //Add url to iframe source
if(!this.$scope[`${this.$scope.geo}IsLoaded`]){
  document.getElementById(`wle${`${this.$scope.geo}`}Frame`).src = url;
  document.getElementById(`wle${`${this.$scope.geo}`}Frame`).onload = function () {
    if(geo === 'regional'){
      $scope.showCountyTitle = false;
      $scope.showRegionTitle = true;
      $scope.showJurisTitle = false;
      $('#loadingRegion').hide();
      $scope.regionalIsLoaded = true;
    } else if(geo === 'county'){
      $scope.showCountyTitle = true;
      $scope.showRegionTitle = false;
      $scope.showJurisTitle = false;
      $('#loadingCounty').hide();
      $scope.countyIsLoaded = true;
    } else if(geo === 'jurisdiction'){
      $scope.showCountyTitle = false;
      $scope.showRegionTitle = false;
      $scope.showJurisTitle = true;
      $('#loadingJuris').hide();
      $scope.jurisdictionIsLoaded = true;
    }
    //Hide the filter panel after loading
    // setTimeout(function () {
    //   $scope.loading = false;
    //   toggleFilterPanel();
    // }, 2000);
  };
}



    // Function to hide filter panel in mode iframe
    function toggleFilterPanel() {
      const message = {
        type: "reportFilterPanelDisplay",
        showPanel: false,
      };
      const iframe = window.document.querySelector("iframe");
      iframe.contentWindow.postMessage(message, "*");
    }
  }


  updateGeography(geo){
    
   
    this.$scope.geo = geo;
    if(this.$scope.geo === 'county'){
      this.$scope.name = this.$scope.county;
      this.$scope.countyIsLoaded = false;
      this.$scope.showCountyTitle = true;
      this.$scope.showRegionTitle = false;
      this.$scope.showJurisTitle = false;
    } else if(this.$scope.geo === 'jurisdiction'){
      this.$scope.name = this.$scope.jurisdiction;
      this.$scope.jurisdictionIsLoaded = false;
      this.$scope.showCountyTitle = false;
      this.$scope.showRegionTitle = false;
      this.$scope.showJurisTitle = true;
    } else {
      this.$scope.showCountyTitle = false;
      this.$scope.showRegionTitle = true;
      this.$scope.showJurisTitle = false;
    }
    console.log(this.$scope.geo);
    console.log(this.$scope.name);
   
    this.$http
    .get(`https://api.mtcanalytics.org/api/mode/dashboard/${this.$scope.geo}/${this.$scope.name}`)
    .then((response) => {
      console.log(response);
      this.$scope[`${this.$scope.geo}Url`] = response.data;
      console.log(response);
      console.log("response 1");
      window.onload = this.loadIframe(this.$scope[`${this.$scope.geo}Url`]);
    
      this.$scope.loading = false;
      
    })
    .catch((err) => {
      console.log(err);
    });
  
   
  }



  updateDashboard() {
    $("#loadingDiv").css("visibility", "visible");
    console.log(this.$scope.jurisdiction);
    // Get list of my sites
    this.getMyList();

    this.$http
      .get(`https://api.mtcanalytics.org/api/mode/dashboard/jurisdiction/${this.$scope.jurisdiction}`)
      .then((response) => {
        console.log(response.data);
        this.loadIframe(response.data[0].dashURL);
      })
      .catch((err) => {
        console.log(err);
      });
  }


}

export default angular
  .module("hessApplicationApp.pdashboard", [uiRouter])
  .config(routes)
  .component("pdashboard", {
    template: require("./pdashboard.html"),
    controller: PdashboardComponent,
    controllerAs: "pdashboardCtrl",
  }).name;



// WEBPACK FOOTER //
// ./client/app/pdashboard/pdashboard.component.js